"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenContent = exports.Token = void 0;
const pinCodeModal_controller_1 = __importDefault(require("xchelper/controllers/pinCodeModal.controller"));
const buffer_1 = require("buffer");
class JitsiOptions {
    constructor(roomName, parentNode, userInfo, jwt, configOverwrite, onload) {
        this.roomName = roomName;
        this.parentNode = parentNode;
        this.userInfo = userInfo;
        this.jwt = jwt;
        this.configOverwrite = configOverwrite;
        this.onload = onload;
    }
}
class Token {
    constructor(raw, content) {
        this.raw = raw;
        this.content = content;
    }
}
exports.Token = Token;
class TokenContent {
    constructor(iss, room, sub, aud, roomuuid, roomdisplayname, roomnumber, requirepin, expiry, timestamp) {
        this.iss = iss;
        this.room = room;
        this.sub = sub;
        this.aud = aud;
        this.roomuuid = roomuuid;
        this.roomdisplayname = roomdisplayname;
        this.roomnumber = roomnumber;
        this.requirepin = requirepin;
        this.expiry = expiry;
        this.timestamp = timestamp;
    }
}
exports.TokenContent = TokenContent;
class JitsiProxy {
    constructor($window, electronWrapper, XucUser, $rootScope, XucLink, $log, $http, $uibModal, MeetingroomsInviteManager, XucVideoEventManager, toast, $translate) {
        this.$window = $window;
        this.electronWrapper = electronWrapper;
        this.XucUser = XucUser;
        this.$rootScope = $rootScope;
        this.XucLink = XucLink;
        this.$log = $log;
        this.$http = $http;
        this.$uibModal = $uibModal;
        this.MeetingroomsInviteManager = MeetingroomsInviteManager;
        this.XucVideoEventManager = XucVideoEventManager;
        this.toast = toast;
        this.$translate = $translate;
        this.ERR_VIDEO_ALREADY_STARTED = "ERR_VIDEO_ALREADY_STARTED";
        this.ERR_CANNOT_START_MEETINGROOM = "ERR_CANNOT_START_MEETINGROOM";
        this.JITSI_IFRAME_LOADED = "JITSI_IFRAME_LOADED";
        this.VIDEO_NEEDS_PIN_CODE = "pinCode";
        this.VIDEO_START_EVENT = "EventStartVideo";
        this.VIDEO_START_ERROR_EVENT = "EventStartVideoError";
        this.VIDEO_SHOW_PHONEBAR_EVENT = "EventShowPhoneBar";
        this.VIDEO_END_EVENT = "EventCloseVideo";
        this.VIDEO_KICKED_EVENT = "EventKicked";
        this.VIDEO_INVITATION_ACCEPT = "EventVideoInvitationAccept";
        this.VIDEO_INVITATION_REFUSE = "EventVideoInvitationRefuse";
        this.VIDEO_INVITATION_TIMEOUT = "EventVideoInvitationTimeout";
        this.INFO_KICKED_BY = "INFO_KICKED_BY";
        this.timeout = 5000;
        this.showPhoneBar = true;
        this.electronJitsiRunning = false;
        this.jitsiAvailable = false;
        this.startVideo = (roomId, roomType) => __awaiter(this, void 0, void 0, function* () {
            return this.initJitsi(this.getMeetingRoomToken(roomId, roomType, this.getToken, this.parseToken), false);
        });
        this.joinOngoingVideo = (token) => __awaiter(this, void 0, void 0, function* () {
            this.initJitsi(Promise.resolve(token), true);
        });
        this.videoIsOngoing = () => {
            return (this.jitsiApiObj != undefined || this.electronJitsiRunning);
        };
        this.validateToken = (token, userData, pin) => {
            return this.$http.get(this.getUrlValidateToken(token, pin), { headers: { 'Authorization': `Bearer ${userData.token}` }, timeout: this.timeout });
        };
        this.inviteToMeetingRoom = (username, displayName, token = this.storedToken) => {
            if (token)
                this.MeetingroomsInviteManager.sendInvitation(username, displayName, token.raw);
        };
        this.startPointToPointVideoCall = (username, displayName) => __awaiter(this, void 0, void 0, function* () {
            let userData = yield this.XucLink.whenLogged();
            let rawToken = yield this.getToken(displayName, userData, 'temporary');
            let token = this.parseToken(rawToken.data.token);
            this.joinOngoingVideo(token);
            this.inviteToMeetingRoom(username, displayName, token);
        });
        this.acceptInvitation = (inviteSequence, username, token) => {
            this.$rootScope.$emit(this.VIDEO_INVITATION_ACCEPT);
            this.MeetingroomsInviteManager.acceptInvitation(inviteSequence, username, token);
            this.joinOngoingVideo(this.parseToken(token));
        };
        this.rejectInvitation = (inviteSequence, username) => {
            this.$rootScope.$emit(this.VIDEO_INVITATION_REFUSE);
            this.MeetingroomsInviteManager.rejectInvitation(inviteSequence, username);
        };
        this.togglePhoneBar = () => {
            this.showPhoneBar = !this.showPhoneBar;
            if (this.showPhoneBar)
                this.$rootScope.$emit(this.VIDEO_SHOW_PHONEBAR_EVENT);
        };
        this.getShowPhoneBar = () => {
            return this.showPhoneBar;
        };
        this.dismissVideo = () => {
            if (this.jitsiApiObj)
                this.jitsiApiObj.dispose();
            this.jitsiApiObj = undefined;
            this.$rootScope.$emit(this.VIDEO_END_EVENT);
            this.$window.Cti.videoEvent(this.XucVideoEventManager.EVENT_VIDEO_END);
            this.storedToken = undefined;
        };
        this.subscribeToStartVideo = (scope, callback) => {
            var handler = this.$rootScope.$on(this.VIDEO_START_EVENT, (callback));
            scope.$on('$destroy', handler);
        };
        this.subscribeToStartVideoError = (scope, callback) => {
            var handler = this.$rootScope.$on(this.VIDEO_START_ERROR_EVENT, callback);
            scope.$on('$destroy', handler);
        };
        this.subscribeToCloseVideo = (scope, callback) => {
            var handler = this.$rootScope.$on(this.VIDEO_END_EVENT, callback);
            scope.$on('$destroy', handler);
        };
        this.subscribeToShowPhoneBar = (scope, callback) => {
            var handler = this.$rootScope.$on(this.VIDEO_SHOW_PHONEBAR_EVENT, callback);
            scope.$on('$destroy', handler);
        };
        this.muteMicrophoneInJitsi = () => {
            var _a;
            if (this.electronJitsiRunning) {
                this.electronWrapper.muteJitsi();
                return Promise.resolve(true);
            }
            else {
                return (_a = this.jitsiApiObj) === null || _a === void 0 ? void 0 : _a.isAudioMuted().then(muted => {
                    var _a;
                    if (!muted)
                        (_a = this.jitsiApiObj) === null || _a === void 0 ? void 0 : _a.executeCommand('toggleAudio');
                });
            }
        };
        this.parseToken = (token) => {
            try {
                const jsonVal = JSON.parse(buffer_1.Buffer.from(token.split('.')[1], 'base64').toString('utf8'));
                return new Token(token, new TokenContent(jsonVal.iss, jsonVal.room, jsonVal.sub, jsonVal.aud, jsonVal.roomuuid, jsonVal.roomdisplayname, jsonVal.roomnumber, jsonVal.requirepin, jsonVal.expiry, jsonVal.timestamp));
            }
            catch (e) {
                throw `Cannot decode token ${token} for meetingRoom : ${e}`;
            }
        };
        this.checkPinCode = (token, tokenDecoder) => {
            return new Promise((resolve) => __awaiter(this, void 0, void 0, function* () {
                let userData = yield this.XucLink.whenLogged();
                if (!token.content.requirepin) {
                    resolve(token);
                }
                else {
                    let tokenPinValidated = yield this.pinCodeModal(token.raw, userData).result;
                    resolve(tokenDecoder(tokenPinValidated));
                }
            }));
        };
        this.onIframeLoaded = () => {
            this.$rootScope.$emit(this.JITSI_IFRAME_LOADED);
        };
        this.initJitsi = (tokenGetter, isInvite, tradeTokenForCookie = this.tradeTokenForCookie, parseToken = this.parseToken) => __awaiter(this, void 0, void 0, function* () {
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                if (this.videoIsOngoing()) {
                    this.$rootScope.$emit(this.VIDEO_START_ERROR_EVENT, this.ERR_VIDEO_ALREADY_STARTED);
                    reject(this.ERR_VIDEO_ALREADY_STARTED);
                }
                else {
                    try {
                        let token = yield tokenGetter;
                        yield tradeTokenForCookie(token);
                        this.storedToken = (isInvite) ? token : yield this.checkPinCode(token, parseToken);
                        let roomNumber = (this.storedToken.content.roomnumber) ? " (**" + this.storedToken.content.roomnumber + ")" : "";
                        resolve(this.startJitsi(this.storedToken.content.roomuuid, this.storedToken.content.roomdisplayname + roomNumber, token.raw));
                    }
                    catch (error) {
                        this.$log.debug(`Cannot start meetingroom`, error);
                        reject(this.ERR_CANNOT_START_MEETINGROOM);
                        this.$rootScope.$emit(this.VIDEO_START_ERROR_EVENT, this.ERR_CANNOT_START_MEETINGROOM);
                    }
                }
            }));
        });
        this.onKickedOut = (event) => {
            var _a;
            if (event.kicked.local) {
                let kickerName = (event.kicker.displayName) ? event.kicker.displayName : (_a = this.jitsiApiObj) === null || _a === void 0 ? void 0 : _a.getDisplayName(event.kicker.id);
                this.toast({
                    duration: 3000,
                    message: `${this.$translate.instant(this.INFO_KICKED_BY)} ${kickerName}`,
                    className: 'basic-toast',
                    position: "center",
                    container: '.toast-container'
                });
                this.dismissVideo();
            }
        };
        this.startJitsi = (roomuuid, roomdisplayname, token) => {
            if (this.electronWrapper.isElectron()) {
                this.electronWrapper.startJitsi(roomuuid, roomdisplayname, token, this.userName);
            }
            else {
                this.jitsiApiObj = new this.$window.JitsiMeetExternalAPI(this.getVideoDomain(), new JitsiOptions(roomuuid, document.querySelector('#meet'), { displayName: this.userName }, token, { subject: roomdisplayname, prejoinConfig: { enabled: false } }, this.onIframeLoaded));
                this.jitsiApiObj.addListener('readyToClose', this.dismissVideo);
                this.jitsiApiObj.addListener('participantKickedOut', this.onKickedOut);
                this.$rootScope.$emit(this.VIDEO_START_EVENT);
                this.$window.Cti.videoEvent(this.XucVideoEventManager.EVENT_VIDEO_START);
                return this.jitsiApiObj;
            }
        };
        this.pinCodeModal = (token, userData) => {
            return this.$uibModal.open({
                templateUrl: 'assets/javascripts/xchelper/controllers/pinCodeModal.html',
                controller: pinCodeModal_controller_1.default,
                controllerAs: 'ctrl',
                windowClass: 'callMgtModal',
                resolve: {
                    token: () => {
                        return token;
                    },
                    userData: () => {
                        return userData;
                    }
                }
            });
        };
        this.electronAdvancedVideoEventDecoder = (electronEvent) => {
            try {
                electronEvent = JSON.parse(electronEvent);
            }
            catch (e) {
                console.debug(`Could not parse videoEvent ${electronEvent}`);
            }
            switch (electronEvent.event) {
                case this.VIDEO_KICKED_EVENT:
                    this.onKickedOut(electronEvent.eventFromJitsi);
                    break;
            }
        };
        this.onElectronJitsiEvent = (event, electronEvent) => {
            var _a, _b;
            switch (electronEvent) {
                case this.VIDEO_START_EVENT:
                    this.$rootScope.$emit(this.VIDEO_START_EVENT);
                    this.$window.Cti.videoEvent(this.XucVideoEventManager.EVENT_VIDEO_START);
                    (_a = document.getElementById("jitsi-video")) === null || _a === void 0 ? void 0 : _a.classList.add("foreground");
                    this.electronJitsiRunning = true;
                    break;
                case this.VIDEO_END_EVENT:
                    this.$rootScope.$emit(this.VIDEO_END_EVENT);
                    this.$window.Cti.videoEvent(this.XucVideoEventManager.EVENT_VIDEO_END);
                    (_b = document.getElementById("jitsi-video")) === null || _b === void 0 ? void 0 : _b.classList.remove("foreground");
                    this.electronJitsiRunning = false;
                    break;
                default:
                    this.electronAdvancedVideoEventDecoder(electronEvent);
                    break;
            }
        };
        this.isApiReachable = () => {
            this.$http.get("/video/external_api.js").then(() => {
                this.jitsiAvailable = true;
            }).catch(() => {
                this.$log.warn("Jitsi not reachable : cannot instatiate meetingrooms");
            });
        };
        this.getVideoDomain = () => {
            return this.$window.externalConfig.host + '/video';
        };
        this.getToken = (roomId, userData, roomType) => {
            return this.$http.get(this.getUrlForMeetingroom(roomId, roomType), { headers: { 'Authorization': `Bearer ${userData.token}` }, timeout: this.timeout });
        };
        this.baseUrl = () => {
            return this.XucLink.getServerUrl('http') + `/xuc/api/2.0/config/meetingrooms`;
        };
        this.getUrlForMeetingroom = (roomId, roomType) => {
            let baseUrl = this.baseUrl();
            return `${baseUrl}/${roomType}/token/${roomId}`;
        };
        this.getUrlValidateToken = (token, pin) => {
            let url = `${this.XucLink.getServerUrl('http')}/meetingrooms/token/validate/${token}`;
            if (pin !== undefined) {
                url += `?pin=${pin}`;
            }
            return url;
        };
        this.getMeetingRoomToken = (roomId, roomType, tokenGetter = this.getToken, tokenDecoder) => __awaiter(this, void 0, void 0, function* () {
            let userData = yield this.XucLink.whenLogged();
            let token = yield tokenGetter(roomId, userData, roomType);
            return tokenDecoder(token.data.token);
        });
        this.tradeTokenForCookie = (token, tokenValidator = this.validateToken) => __awaiter(this, void 0, void 0, function* () {
            let userData = yield this.XucLink.whenLogged();
            yield tokenValidator(token.raw, userData, undefined);
        });
        this.init = () => {
            this.$log.info("Starting jitsiProxy service");
            this.isApiReachable();
            this.XucUser.getUserAsync().then((user) => {
                this.userName = user.fullName;
            });
            this.$rootScope.$on('JITSI_EVENT', this.onElectronJitsiEvent);
            this.XucLink.whenLoggedOut().then(this.uninit);
            this.$rootScope.$on('linkDisConnected', () => {
                if (this.videoIsOngoing())
                    this.dismissVideo();
            });
        };
        this.uninit = () => {
            this.$log.info("Unloading jitsiProxy service");
            if (this.jitsiApiObj)
                this.dismissVideo();
            this.showPhoneBar = true;
            this.userName = undefined;
            this.XucLink.whenLogged().then(this.init);
        };
        this.init();
    }
}
exports.default = JitsiProxy;
JitsiProxy.$inject = [
    "$window", "electronWrapper", "XucUser", "$rootScope",
    "XucLink", "$log", "$http", "$uibModal",
    "MeetingroomsInviteManager", "XucVideoEventManager",
    "toast", "$translate"
];
